import { IonAlert, IonToast } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setShowAnullModal } from "../../../store/documentShow";
import { selectDocument } from "../../../store/documentShow/selectors/selectDocument";
import { setAnullStatus } from "../../../store/documentUpdate";
import { selectAnullStatus } from "../../../store/documentUpdate/selectors/selectAnullStatus";
import { selectShowAnullModal } from "../../../store/documentShow/selectors/selectShowAnullModal";
import { addDocumentHistory } from "../../../store/documentUpdate/actions/addDocumentHistory";
import { anullDocument } from "../../../store/documentUpdate/actions/anullDocument";

export const AnullDocument = () => {
  const dispatch = useDispatch();
  const showAlert = useSelector(selectShowAnullModal);
  const anullStatus = useSelector(selectAnullStatus);
  const document = useSelector(selectDocument);

  return (
    <>
      {document.status?.name !== "Anulado" && (
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => dispatch(setShowAnullModal(false))}
          header="¿Seguro que quieres anular este acuerdo?"
          buttons={[
            "Volver",
            {
              text: "anular acuerdo",
              handler: (d) => {
                dispatch(anullDocument());
                dispatch(addDocumentHistory("anuló el acuerdo"));
              },
            },
          ]}
        />
      )}

      <IonToast
        isOpen={anullStatus === "fulfilled"}
        message="Acuerdo anulado correctamente"
        position="top"
        onWillDismiss={() => dispatch(setAnullStatus(""))}
        duration={6000}
        color="success"
      />

      <IonToast
        isOpen={anullStatus === "pending"}
        message="Anulando acuerdo..."
        position="top"
        duration={6000}
        color="primary"
      />
    </>
  );
};
